import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Imgsec4 = () => {
  return (
    <section className="image-grid-section ">
      <Container>
        <Row className="justify-content-center">
          <Col xs={6} md={3} className="mb-4 text-center">
            <img 
              src="assets/img/Doors/img(uv_digital23).png" 
              alt="Transport Service 10"
              className="img-fluid rounded shadow mx-auto d-block"
              width="212"
              height="100"
            />
          </Col>
          <Col xs={6} md={3} className="mb-4 text-center">
            <img 
              src="assets/img/Doors/img(uv_digital24).png"
              alt="Transport Service 2"
              className="img-fluid rounded shadow mx-auto d-block"
              width="212"
              height="100"
            />
          </Col>
          <Col xs={6} md={3} className="mb-4 text-center">
            <img 
              src="assets/img/Doors/img(uv_digital25).png"
              alt="Transport Service 3"
              className="img-fluid rounded shadow mx-auto d-block"
              width="212"
              height="100"
            />
          </Col>
          <Col xs={6} md={3} className="mb-4 text-center">
            <img 
              src="assets/img/Doors/img(uv_digital26).png"
              alt="Transport Service 4"
              className="img-fluid rounded shadow mx-auto d-block"
              width="212"
              height="100"
            />
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col xs={6} md={3} className="mb-4 text-center">
            <img 
              src="assets/img/Doors/img(uv_digital27).jpg" 
              alt="Transport Service 10"
              className="img-fluid rounded shadow mx-auto d-block"
            />
          </Col>
          <Col xs={6} md={3} className="mb-4 text-center">
            <img 
              src="assets/img/Doors/img(uv_digital28).jpg"
              alt="Transport Service 2"
              className="img-fluid rounded shadow mx-auto d-block"
            />
          </Col>
          <Col xs={6} md={3} className="mb-4 text-center">
            <img 
              src="assets/img/Doors/img(uv_digital29).jpg"
              alt="Transport Service 3"
              className="img-fluid rounded shadow mx-auto d-block"
            />
          </Col>
          <Col xs={6} md={3} className="mb-4 text-center">
            <img 
              src="assets/img/Doors/img(uv_digital30).jpg"
              alt="Transport Service 4"
              className="img-fluid rounded shadow mx-auto d-block"
              width="212"
              height="400"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Imgsec4;
